export default __webpack_public_path__ + "static/media/Satisfy.32a67135.ttf";